<template>
  <div class="mt-md-0 mt-2">
    <div class="details-title">{{ title }}</div>
    <div class="card card-body card-account bg-light">
      <div class="row">
        <div class="col-md-8">
          <p>{{ accountData.unloading_method_string }}</p>
        </div>
        <div class="col-md-5 text-right">
          <div @click="$bvModal.show('unloading-details-modal')" class="link">Wijzig</div>
        </div>
      </div>
    </div>

    <b-modal ref="unloading-details-modal" id="unloading-details-modal" footer-class="modal-footer modal-save-details" size="sm" centered>
      <template slot="modal-header">
        <h4 class="modal-title">{{ title }}</h4>
        <button type="button" aria-label="Close" @click="hideModal" class="close">
          <font-awesome-icon class="font-awesome-icon" icon="times-circle"/>
        </button>
      </template>
      <template slot="default">
        <div class="col-md-13">
          <form @submit.prevent="onSubmit">
            <div class="form-row">
              <div class="col-md-13">
                <label for="unloading-method" class="col-form-label"></label>
                <select
                  v-model="unloading_method"
                  class="form-control"
                  id="unloading-method"
                  name="unloading-method"
                >
                  <option
                    v-for="unloadingMethod in unloadingMethods"
                    v-bind:key="unloadingMethod.id"
                    :value="unloadingMethod.id"
                  >
                    {{ unloadingMethod.text }}
                  </option>
                </select>
              </div>
            </div>
          </form>
        </div>

        <div
          v-if="unloadingDetailsStatus"
          class="col-md-13 mt-2 alert"
          role="alert"
          :class="{ 'alert-success': unloadingDetailsStatus.success, 'alert-danger': !unloadingDetailsStatus.success }"
        >
          <strong>{{ unloadingDetailsStatus.message }}</strong>
        </div>
      </template>
      <template slot="modal-footer">
        <button
          @click="saveDetails"
          type="button"
          class="btn btn-oldevuuren btn-round w-100">Losmethode opslaan
          <font-awesome-icon class="font-awesome-icon" v-if="unloadingDetailsBusy" icon="spinner" spin/>
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { MUTATE_UNLOADING_DETAILS_STATUS, SAVE_UNLOADING_DETAILS } from '../../../store/types'

  export default {
    props: ['accountData'],
    data() {
      return {
        title: 'Losmethode',
        unloading_method: this.accountData.unloading_method,
        unloadingMethods: [
          { id: null, text: 'Selecteer losmethode' },
          { id: 0, text: 'Kooiaap' },
          { id: 1, text: 'Handklant' }
        ]
      }
    },
    computed: {
      unloadingDetailsStatus() {
        return this.$store.getters.unloadingDetailsStatus
      },
      unloadingDetailsBusy() {
        return this.$store.getters.unloadingDetailsBusy
      }
    },
    methods: {
      hideModal() {
        // hide
        this.$refs['unloading-details-modal'].hide()
        // discard changes
        this.unloading_method = this.accountData.unloading_method
      },
      saveDetails() {
        const formData = {
          unloading_method: this.unloading_method
        }
        this.$store.dispatch(SAVE_UNLOADING_DETAILS, formData).then(() => {
          if (this.unloadingDetailsStatus.success) {
            this.$refs['unloading-details-modal'].hide()
          }
        })
      }
    },
    mounted() {
      const store = this.$store
      this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
        store.commit(MUTATE_UNLOADING_DETAILS_STATUS, null)
      })
    }
  }
</script>

<style lang="scss" scoped>
</style>
